import moment from 'moment'
export default class BankingListModel {
  constructor(data) {
    this.id = data.id || undefined
    this.bankAccountId = data.bankAccountId
    // the booking api sometimes returns a wrong calculated date (e.g. 01.01.0001), in this case we do not show a date
    this.date = moment(data.bookingDate).year() > 1980 ? data.bookingDate : null
    this.recipient = data.bookingContactName
    this.iban = data.bookingIban
    this.bic = data.bookingBankIdentifier
    this.reference = data.purposeDescription
    this.displayAmount = data.bookingAmount
    this.amount = data.bookingAmount
    this.valueDate = data.valutaDate
    this.booked = data.booked
    this.assignmentState = data.assignmentState
    this.state = data.assignmentState
    this.categorization = data.categorization || {}
    this.assignments = data.assignments || []
    this.menu = ''
    this.bankAccountName = data.bankAccountName
    this.cashBookingType = data.cashBookingType || null
    this.orderId = data.orderId
    this.cashlessPaymentProvider = data.cashlessPaymentProvider
    this.endOfDayBalance = data.isAccountBalance ? data.accountBalance : null

  }
}
